import type { User } from '@/utils/types/User';

import { useUserQuery } from './user-query';

export const useCurrentUser = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { data: user, isLoading, isError, error, status } = useUserQuery({ enabled });

  return {
    user: user as User,
    isLoading,
    isError,
    error,
    status,
  };
};
